import React from "react";

const ALERT_STYLES = [
  {
    maxPoints: 1.5,
    label: "High risk",
    className: "border-red-200 bg-red-50 text-red-700",
    copy: "Any lower and this falls",
  },
  {
    maxPoints: 4,
    label: "Be careful",
    className: "border-amber-200 bg-amber-50 text-amber-700",
    copy: "A small drop takes this",
  },
  {
    maxPoints: Infinity,
    label: "Good buffer",
    className: "border-emerald-200 bg-emerald-50 text-emerald-700",
    copy: "There is still some room before this falls",
  },
];

const getLowerGradeLabel = (grade) => {
  if (grade <= 1) {
    return "below grade 1";
  }

  return `to a ${grade - 1}`;
};

export default function GradeBoundaryAlert({ grade, pointsAboveBoundary, appearance = "panel" }) {
  if (grade == null || !Number.isFinite(pointsAboveBoundary)) {
    return null;
  }

  const tone =
    ALERT_STYLES.find((style) => pointsAboveBoundary < style.maxPoints) ||
    ALERT_STYLES[ALERT_STYLES.length - 1];
  const formattedPoints = pointsAboveBoundary.toFixed(1);
  const message =
    grade <= 1
      ? `${formattedPoints} percentage points above the grade 1 boundary. Any lower and this falls below grade 1.`
      : `${formattedPoints} percentage points above the grade ${grade} boundary. ${tone.copy} ${getLowerGradeLabel(grade)}.`;

  return (
    <p className={appearance === "quiet" ? "grade-boundary-note" : `mt-2 rounded-xl border px-3 py-2 text-sm leading-5 ${tone.className}`}>
      <span className="font-semibold">{tone.label}:</span> {message}
    </p>
  );
}
